import { createSelector } from 'reselect'

const getVotesListings = (state: any) => state.votesListings

/** A Redux selector to retrieve Votes count
 * @param state - The Redux state
 * @param {object} - Votes Listings data.
 */

export const selectVotesListings = createSelector(
  getVotesListings,
  (data) => data && data.votesListings ? data.votesListings : null
)

/** A Redux selector to retrieve Latest Votes List Is Loading state
 * @param state - The Redux state
 * @param {Boolean} - Fetching Latest Votes list Is Loading
 */

export const selectVotesListIsLoading = createSelector(
  getVotesListings,
  (data) => data && data.status ? data.status.isLoading : null
)

/** A Redux selector to retrieve Latest Total Votes Count state
 * @param state - The Redux state
 * @param {Number} - Fetching Latest Total Votes Count
 */

export const selectTotalVotesCount = createSelector(
  getVotesListings,
  (data) => data && data.totalVoteCount ? data.totalVoteCount : 0
)
